import script from "./Record.vue?vue&type=script&setup=true&lang=js"
export * from "./Record.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__